const USCurrencyFormmater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

/** 美元貨幣格式化器（Intl.NumberFormat，en-US、無小數位） */
export default USCurrencyFormmater;
